"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageTypeToAbsoluteImmunity = exports.DamageTypeToImmunity = void 0;
const AttributeType_1 = require("../enums/AttributeType");
const DamageType_1 = require("../enums/DamageType");
exports.DamageTypeToImmunity = {
    [DamageType_1.DamageType.Chaos]: AttributeType_1.AttributeType.ChaosDamageImmunity,
    [DamageType_1.DamageType.Death]: AttributeType_1.AttributeType.DeathDamageImmunity,
    [DamageType_1.DamageType.Fire]: AttributeType_1.AttributeType.FireDamageImmunity,
    [DamageType_1.DamageType.Frost]: AttributeType_1.AttributeType.FrostDamageImmunity,
    [DamageType_1.DamageType.Holy]: AttributeType_1.AttributeType.HolyDamageImmunity,
    [DamageType_1.DamageType.Nature]: AttributeType_1.AttributeType.NatureDamageImmunity,
    [DamageType_1.DamageType.Physical]: AttributeType_1.AttributeType.PhysicalDamageImmunity,
    [DamageType_1.DamageType.Sonic]: AttributeType_1.AttributeType.SonicDamageImmunity,
    [DamageType_1.DamageType.None]: AttributeType_1.AttributeType.None,
    [DamageType_1.DamageType.All]: AttributeType_1.AttributeType.AllDamageImmunity
};
exports.DamageTypeToAbsoluteImmunity = {
    [DamageType_1.DamageType.Chaos]: AttributeType_1.AttributeType.AbsoluteChaosDamageImmunity,
    [DamageType_1.DamageType.Death]: AttributeType_1.AttributeType.AbsoluteDeathDamageImmunity,
    [DamageType_1.DamageType.Fire]: AttributeType_1.AttributeType.AbsoluteFireDamageImmunity,
    [DamageType_1.DamageType.Frost]: AttributeType_1.AttributeType.AbsoluteFrostDamageImmunity,
    [DamageType_1.DamageType.Holy]: AttributeType_1.AttributeType.AbsoluteHolyDamageImmunity,
    [DamageType_1.DamageType.Nature]: AttributeType_1.AttributeType.AbsoluteNatureDamageImmunity,
    [DamageType_1.DamageType.Physical]: AttributeType_1.AttributeType.AbsolutePhysicalDamageImmunity,
    [DamageType_1.DamageType.Sonic]: AttributeType_1.AttributeType.AbsoluteSonicDamageImmunity,
    [DamageType_1.DamageType.None]: AttributeType_1.AttributeType.None,
    [DamageType_1.DamageType.All]: AttributeType_1.AttributeType.AbsoluteAllDamageImmunity,
};
